import React, { ReactElement, cloneElement, forwardRef, Ref } from 'react'
import { Box, BoxProps, Rows, FlexProps } from '../../design-system'
import { Responsive } from '../../design-system'

interface SectionProps extends FlexProps {
  bgGraphic?: ReactElement<BoxProps>
  id?: string
  padding?: Responsive<number>
  wide?: boolean
}

export const sectionDefaultPadding = { mobile: 2, desktop: 3 }

export const Section = forwardRef(
  (
    {
      bg,
      bgGraphic,
      id,
      wide,
      padding = sectionDefaultPadding,
      overflow = 'hidden',
      ...props
    }: SectionProps,
    ref: Ref<HTMLDivElement>,
  ) => (
    <Rows
      ref={ref}
      width="100%"
      provide
      overflow={overflow}
      alignItems="center"
      bg={bg}
      id={id}
    >
      {bgGraphic && cloneElement(bgGraphic, { position: 'absolute' })}
      <Box
        padding={padding}
        paddingVertical={
          padding === sectionDefaultPadding
            ? { mobile: 3, desktop: 3 }
            : padding
        }
        overflow="visible"
        maxWidth="100%"
        width={wide ? '100%' : '70em'}
        {...props}
      />
    </Rows>
  ),
)
